import { View, StyleSheet } from "react-native";

function BlankLayout({ children, flexDirection = "row" }) {
  return <View style={[styles.container, { flexDirection }]}>{children}</View>;
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
});

export default BlankLayout;
